import { Section } from './section';
import { HttpClient } from '@angular/common/http';
import { Media } from '../media';
import { Collaborator } from './collaborator/collaborator';
import { StuplayConfig } from '../stuplay-config';
import { Account } from '../account/account';
import { Instance } from './instance';
import { Event } from './section/section-content/event';
import { getParams, cleanObject } from '../helpers';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export class Course {
    id: number;
    courseSubscriptionId?: number;
    languageId: number;
    language: any;
    title: string;
    description: string;
    longDescription?: string;
    shortDescription?: string;
    slug: string;
    requirement?: string;
    target: string;
    purpose: string;
    introMediaId: number;
    media?: Media;
    theme?: string | null;
    resume: any;
    courseCampCount: number;
    duration: number;
    sections?: Section[];
    category?: string;
    collaborators?: Collaborator[];
    instances?: Instance[];
    courseFolderId: number;
    weeklyWorkingDuration: number;
    updatedAt: string;
    mode: string;
    hash: string;
    type?: string;
    surveyId: boolean;
    courseCampId: any;
    createdAt: any;
    schema: string;
    settings?: any;
    instancesCount: number;
    folderId?: number;
    permissions?: any[];
    hasSurvey?: boolean;
    isOrdered?: boolean;
    isTrajectContent?: boolean;
    shared?: boolean;
    templateId?: number;
    tags?: any;
    realignedAt?: any;
    subscription?: any;

    constructor(course: any, private http: HttpClient, private stuplayConfig: StuplayConfig) {
        this.extends(course);
    }

    extends(course: any): Course {
        Object.assign(this, course);
        if (this.sections && this.sections.length > 0) {
            this.sections = this.sections.map((section) => new Section(section, this.http, this.stuplayConfig));
        }
        if (this.collaborators && this.collaborators.length > 0) {
            this.collaborators = this.collaborators.map((collaborator) => new Collaborator(collaborator));
        }
        if (this.instances && this.instances.length > 0) {
            this.instances = this.instances.map((instance) => new Instance(instance));
        }
        return this;
    }

    addMedia(media: Media): Observable<Course> {
        return this.http.post(`${this.stuplayConfig.envVar.API_URL}/media/embed`, cleanObject(this)).pipe(map(() => {
            this.media = media;
            return this;
        }));
    }

    deleteMedia(mediaId: number): Observable<any> {
        return this.http.delete(`${this.stuplayConfig.envVar.API_URL}/media/${mediaId}`);
    }

    addSection(): Observable<Course> {
        return this.http.post(`${this.stuplayConfig.envVar.STUDIO_URL}/course/${this.id}/section?includes=section-contents`, { courseId: this.id })
            .pipe(map((res) => {
                this.sections.push(new Section(res, this.http, this.stuplayConfig));
                return this;
            }));
    }

    getCollaborators(): Observable<Collaborator[]> {
        return this.http.get(`${this.stuplayConfig.envVar.API_URL}/courses/${this.id}/collaborators`)
            .pipe(map((collaboratorsObject: any) => collaboratorsObject.map((collaboratorObject) => new Collaborator(collaboratorObject))));
    }

    addCollaborator(account: Account, companyId: number): Observable<Collaborator> {
        return this.http.post(`${this.stuplayConfig.envVar.API_URL}/courses/${this.id}/collaborators`, {
            accountId: account?.id,
            roleId: 1,
            isActive: true,
            companyId: companyId
        }).pipe(map((collaboratorObject) => new Collaborator(collaboratorObject)));
    }

    updateCollaborator(account: Account, roleId: number = 1, isActive: boolean = false, companyId: number): Observable<Collaborator> {
        return this.http.put(`${this.stuplayConfig.envVar.API_URL}/courses/${this.id}/collaborators/${account?.id}`, {
            accountId: account?.id,
            roleId: roleId,
            isActive: isActive,
            companyId: companyId
        }).pipe(map((collaboratorObject) => new Collaborator(collaboratorObject)));
    }

    deleteCollaborator(account: Account): Observable<void> {
        return this.http.delete(`${this.stuplayConfig.envVar.API_URL}/courses/${this.id}/collaborators/${account?.id}`).pipe(map(res => null));
    }

    update(companyId): Observable<Course> {
        return this.http.put(`${this.stuplayConfig.envVar.API_URL}/create/courses/${this.id}?includes=sections.sectionContents,categories&company_id=${companyId}`, cleanObject(this)).pipe(map(res => this.extends(res)));
    }

    delete(params?: any): Observable<void> {
        return this.http.delete(`${this.stuplayConfig.envVar.STUDIO_URL}/course/${this.id}`, { params: getParams(params) }).pipe(map(res => null));
    }

    getEvents() {
        return this.http.get(`${this.stuplayConfig.envVar.API_URL}/course/${this.id}/events?includes=event_sessions`)
            .pipe(map((data: any) => {
                return data.events.map((event) => {
                    return new Event(event, this.http, this.stuplayConfig);
                })
            }));
    }
}
